import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  Button,
  CssBaseline,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Link,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BlueIcon from "../assets/Blue.png";
import CpfCnpjMask from "../components/CpfCnpjMaks";
import PhoneNumberMask from "../components/PhoneNumberMask";
import ValidadCpfCnpj from "../utils/ValidCpfCnpj";
import api from "../services/api";

export default function Register() {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [created, setCreated] = useState(false);

  const handleClickShowPassword = (event) => {
    setShowPassword(event.target.checked);
  };

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const password = data.get("new-password");
    const ipassword = data.get("reapeat-password");
    const email = data.get("new-email");
    const mailformat = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/;
    const cpf_cnpj = data.get("cpf-cnpj");

    if (email.match(mailformat) === null) {
      setError("email");
      return;
    }
    if (!ValidadCpfCnpj(cpf_cnpj)) {
      setError("cpfCnpj");
      return;
    }

    if (password.length < 7) {
      setError("shortPassword");
      return;
    }
    if (!(password === ipassword)) {
      setError("diffPassword");
      return;
    }

    setError("");
    const user = {
      email,
      password,
      name: data.get("name"),
      cpf_cnpj: data.get("cpf-cnpj"),
      cellphone: data.get("tel"),
      status: "inactive"
    };


    setLoading(true);
    api
      .post("users", user)
      .then((response) => {
        setLoading(false);
        if (response.status === 200 || response.status === 201) {
          setCreated(true);
          console.log(response);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err.response.status);
      });
  };

  return (
    <Dialog
      component="form"
      onSubmit={handleSubmit}
      open={open}
      onClose={handleClose}
    >
      <DialogTitle color="primary">
        {created ? "Cadastro realizado com sucesso!" : "Cadastre-se"}
      </DialogTitle>
      {created ? (
        <>
          <DialogContent>
            <DialogContentText>
              O seu cadastro foi realizado, agora você deve aguardar a permissão
              do administrador para ter acesso a nossa plataforma!
              <br />
              <br />
              Para mais informações da nossa empresa e contato com a
              administração:
              <br />
              <Link target="_blank" href="https://blue.cnt.br/">
                Blue Contabilidade Digital
              </Link>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Fechar</Button>
          </DialogActions>
        </>
      ) : (
        <>
          <DialogContent>
            <CssBaseline />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  backgroundImage: `url(${BlueIcon})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  height: "10vh",
                  width: "100%",
                  mb: 2,
                }}
              />
              <Box sx={{ mt: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      autoComplete="given-name"
                      name="name"
                      required
                      fullWidth
                      id="name"
                      label="Nome"
                      helperText="Seu nome ou nome da empresa"
                      autoFocus
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      error={"email" === error}
                      helperText={"email" === error && "E-mail inválido!"}
                      required
                      fullWidth
                      id="new-email"
                      label="E-mail"
                      name="new-email"
                      autoComplete="email"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      fullWidth
                      id="tel"
                      label="Telefone"
                      name="tel"
                      autoComplete="tel"
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        inputComponent: PhoneNumberMask,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      error={"cpfCnpj" === error}
                      helperText={
                        "cpfCnpj" === error && "CPF ou CNPJ inválido!"
                      }
                      required
                      fullWidth
                      variant="outlined"
                      id="cpf-cnpj"
                      label="CPF/CNPJ"
                      name="cpf-cnpj"
                      InputProps={{
                        inputComponent: CpfCnpjMask,
                      }}
                      InputLabelProps={{ shrink: true }}
                      autoComplete="off"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      error={"shortPassword" === error}
                      helperText={
                        "shortPassword" === error &&
                        "A senha deve conter no mínimo 8 caracteres"
                      }
                      required
                      fullWidth
                      name="new-password"
                      label="Senha"
                      type={showPassword ? "text" : "password"}
                      id="new-password"
                      autoComplete="new-password"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      error={"diffPassword" === error}
                      helperText={
                        "diffPassword" === error && "Senhas divergentes"
                      }
                      required
                      fullWidth
                      name="reapeat-password"
                      label="Repita a Senha"
                      type={showPassword ? "text" : "password"}
                      id="reapeat-password"
                      autoComplete="new-password"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Box>
            <FormControlLabel
              control={
                <Checkbox
                  icon={<VisibilityOff />}
                  checkedIcon={<Visibility />}
                  onChange={handleClickShowPassword}
                  checked={showPassword}
                  value="remember"
                  color="primary"
                />
              }
              label="Ver Senha"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancelar</Button>
            <LoadingButton loading={loading} type="submit" variant="contained">
              Cadastrar
            </LoadingButton>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
}
